<template>
  <div class="m-2">
    <b-row>
      <!-- Cantidad de elementos por página -->
      <b-col
        cols="12"
        md="8"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <div>
          <span>Mostrar</span>
          <v-select
            :value="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="(val) => $emit('update:perPage', val || null)"
          />
        </div>
        <!-- <filtro-planes :plan-filter.sync="configRequest.wsParams.plan" /> -->
        <div class="w-100">
          <b-overlay
            :show="isBusy"
            rounded="sm"
          >
            <span>Planes * </span>
            <v-select
              style="text-overflow: ellipsis;"
              :value="planFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="planes"
              class="w-100"
              size="sm"
              label="nombre"
              :reduce="pln => pln.id"
              @input="(val) => aplyPlan(val)"
            />
          </b-overlay>
        </div>
      </b-col>
      <!-- Buscador -->
      <b-col
        cols="12"
        md="2"
      >
        <span>Buscador *</span>
        <div class="d-flex align-items-center justify-content-end">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon
                :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                @click="searchQuery != '' ? searchQuery = '' : ''"
              />
            </b-input-group-prepend>
            <b-form-input
              :value="searchQuery"
              :placeholder="(userRol.id != 1) ? 'Buscar matricula, solicitud, monto' : 'Escriba aqui'"
              @input="(val) => $emit('update:searchQuery', val || '')"
            />
          </b-input-group>
        </div>
      </b-col>
      <!-- estatus -->
      <b-col
        cols="2"
        md="2"
      >
        <label>Estatus</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="statusFilter"
          :options="statusOptions"
          class="w-100"
          size="sm"
          :reduce="val => val.value"
          @input="(val) => $emit('update:statusFilter', val || null)"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BOverlay,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  // BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, onMounted, computed,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { listaPlanes } from '../useCompras'

export default {
  components: {
    vSelect,
    BRow,
    BCol,
    BOverlay,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    // BFormGroup,
  },
  props: {
    planFilter: {
      type: [Number, null],
      default: () => null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    pagaresOptions: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: () => '',
    },
    perPage: {
      type: [Number, null],
      default: () => null,
    },
    perPageOptions: {
      type: [Array, null],
      default: () => null,
    },
    inPlan: {
      type: [Number, null],
      default: () => null,
    },
  },
  setup(props, { emit }) {
    const planes = ref([])
    const toast = useToast()
    const isBusy = ref(false)
    const userRol = computed(() => store.state.cuenta.rolSelected) //* Return current role
    const statusOptions = ref([
      { label: 'Activa', value: 'ACT' },
      { label: 'Cancelada', value: 'CAN' },
      { label: 'Autorizada', value: 'AUT' },
      { label: 'Completo', value: 'COM' },
    ])
    // lista de planes para filtrar los cuatrimestres
    const loadPlanes = () => {
      isBusy.value = true

      listaPlanes(props.inPlan)
        .then(response => {
          planes.value = response.data
          isBusy.value = false
        })
        .catch(error => {
          isBusy.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención en petición [ Planes ]',
              text: `${error} Intente de nuevo por favor.`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          }, { timeout: 10000 })
        })
    }

    const aplyPlan = item => {
      emit('update:planFilter', item || null)
      emit('update:statusFilter', null)
      emit('reloadApi')
    }

    onMounted(
      () => {
        if (props.pagaresOptions.length > 0) {
          statusOptions.value = props.pagaresOptions
        }
        loadPlanes()
      },
    )

    return {
      planes,
      isBusy,
      userRol,
      statusOptions,
      aplyPlan,
    }
  },
}
</script>
